import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { workspaceGuard } from './guards/workspace.guard';

export const routes: Routes = [
  {
    path: 'debug',
    loadComponent: () => import('./pages/debug/debug-page.component').then(m => m.DebugPageComponent),
  },
  {
    path: 'select-workspace',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/select-workspace/select-workspace.component').then(m => m.SelectWorkspaceComponent),
  },
  {
    path: '',
    canActivate: [AuthGuard, workspaceGuard],
    loadChildren: () => import('@sentry/forms').then(m => m.FORMS_ROUTES),
  },
];
